import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { TabDetails } from "models/components/tabDetails";
import { Subscription } from "rxjs";
import { ErrorBannerCloseService } from "services/error-banner-close.service";

@Component({
  selector: "tabs",
  templateUrl: "./tabs.component.html",
})
export class TabsComponent implements OnInit, OnDestroy {
  @Input() componentTabs: TabDetails[] = [];
  @Output() onTabChange = new EventEmitter<number>();

  activeTabId: number = 0;
  private subscription: Subscription;

  constructor(private errorBannerCloseService: ErrorBannerCloseService) {}

  ngOnInit(): void {
    this.subscription = this.errorBannerCloseService.event$.subscribe(
      (data) => {
        this.activateTab(data);
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  activateTab(tabId: number) {
    this.componentTabs.forEach((tab) => {
      if (tab.id == tabId) {
        tab.showTabPage = true;
      }
      tab.showTabPage = false;
    });
    this.activeTabId = tabId;
    this.onTabChange.emit(this.activeTabId);
  }
}



// WEBPACK FOOTER //
// ./src/components/tabs/tabs.component.ts